module.exports = __webpack_public_path__ + "static/media/john-fornander-FIu48iuo_4g-unsplash.123f5239.jpg";